import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';
import { StandardEvents } from '@shopify/events';

class ElaliRecentlyViewed extends HTMLElement {
  connectedCallback() {
    this.events = new AbortController();
    this.cartItemCount = Number(this.dataset.cartItemCount);
    document.addEventListener(RecentlyViewed.eventName, this.load, { signal: this.events.signal });
    document.addEventListener(StandardEvents.cartLinesUpdate, this.updateCart, { signal: this.events.signal });
    this.load();
  }

  disconnectedCallback() {
    this.events.abort();
    this.request?.abort();
  }

  updateCart = async (event) => {
    try {
      const { cart, detail } = await event.promise;
      if (!this.isConnected) return;
      this.cartItemCount = cart?.totalQuantity ?? detail?.itemCount ?? this.cartItemCount;
      this.load();
    } catch {
      // A failed cart change leaves the current cart state intact.
    }
  };

  load = async () => {
    this.request?.abort();
    this.hidden = true;
    const ids = RecentlyViewed.getProducts();
    if (this.cartItemCount > 0 || !ids.length) return;

    const request = new AbortController();
    this.request = request;
    const url = new URL(this.dataset.searchUrl, location.origin);
    url.searchParams.set('q', ids.map(id => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');

    try {
      const html = await sectionRenderer.getSectionHTML(this.dataset.sectionId, false, url, request.signal);
      if (request.signal.aborted || !this.isConnected) return;
      const row = new DOMParser().parseFromString(html, 'text/html').querySelector('elali-recently-viewed elali-product-row');
      const list = row?.querySelector('.elali-featured__row');
      if (!list) return;
      const cards = [...list.children];
      list.replaceChildren(...ids.map(id => cards.find(card => card.querySelector('product-card')?.dataset.productId === id)).filter(Boolean));
      if (!list.children.length) return;
      this.replaceChildren(row);
      this.hidden = false;
    } catch {
      // Keep this optional row hidden if history products cannot be loaded.
    }
  };
}

if (!customElements.get('elali-recently-viewed')) customElements.define('elali-recently-viewed', ElaliRecentlyViewed);
